import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_AI_SETTINGS = {
  id: null,
  isEnabled: false,
  framework: "OLLAMA",
  settings: null,
  isStreamingEnabled: false,
  isRagEnabled: false,
  ragSettings: null,
  isSharepointDownloadEnabled: false,
  authenticationMethod: "IAM",
  genAiManagedByConfig: false,
  ragManagedByConfig: false,
};

export const INITIAL_STATE = {
  settings: INITIAL_AI_SETTINGS,
  areAIConnectionsTested: false,
  edits: {},
  error: false,
  isAiEnabledInitialized: false,
  isTesting: false,
  isLlmAvailable: true,
  analysisLlm: null,
};

export const generativeAiSlice = createSlice({
  name: "generativeAi",
  initialState: INITIAL_STATE,
  reducers: {
    setAreAIConnectionsTested: (state, { payload: areAIConnectionsTested }) => {
      state.areAIConnectionsTested = Boolean(areAIConnectionsTested);
    },
    setGenerativeAISettings: (state, { payload }) => {
      state.settings = payload;
    },
    updateGenerativeAISettings: (state, { payload }) => {
      state.settings = { ...state.settings, ...payload };
    },
    setEdits: (state, { payload }) => {
      state.edits = { ...state.edits, ...payload };
    },
    resetEdits: (state) => {
      state.edits = {};
    },
    setIsTesting: (state, { payload }) => {
      state.isTesting = payload;
    },
    setIsRagEnabled: (state, { payload }) => {
      state.settings.isRagEnabled = payload;
    },
    setIsLocalFileSharingEnabled: (state, { payload }) => {
      state.settings.ragSettings = {
        ...state.settings.ragSettings,
        isLocalFileSharingEnabled: payload,
      };
    },
    setIsLlmAvailable: (state, { payload }) => {
      state.isLlmAvailable = payload;
    },
    setAnalysisLlm: (state, { payload }) => {
      state.analysisLlm = payload;
    },
    setIsAiEnabledInitialized: (state) => {
      state.isAiEnabledInitialized = true;
    },
  },
});

export const {
  setAreAIConnectionsTested,
  setGenerativeAISettings,
  updateGenerativeAISettings,
  setEdits,
  resetEdits,
  setIsAiEnabledInitialized,
  setIsTesting,
  setIsRagEnabled,
  setIsLocalFileSharingEnabled,
  setIsLlmAvailable,
  setAnalysisLlm,
} = generativeAiSlice.actions;

export default generativeAiSlice.reducer;
